import React, { useState } from 'react';
import { useCookies } from 'react-cookie';

import 'bootstrap/dist/css/bootstrap.min.css';

import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import ClickPanel from './components/ClickPanel';
import Timer from './components/Timer';

import { Ellipse } from './types/Ellipse';
import { Image } from './types/Image';

import './App.css';

function App() {
    const [cookies, setCookie] = useCookies(["grill-duel"]);
    const [diffs, setDiffs] = useState<boolean[]>([]);

    const config = ((document as any)?.grillDuelConfig);

    const setDiff = (index: number) => {
        const diffsCopy = diffs.slice();
        diffsCopy[index] = true;
        setDiffs(diffsCopy);
    };

    const leftImage: Image = {
        src: config?.images.left,
        width: 1500,
        height: 866,
    };

    const rightImage: Image = {
        src: config?.images.right,
        width: 1500,
        height: 866,
    };

    const ellipses: Ellipse[] = config?.ellipses;

    const stopCallback = (minutes: number, seconds: number) => {
        setCookie("grill-duel", ('00' + minutes).slice(-2) + " : " + ('00' + seconds).slice(-2));
        document.location = config?.endRedirect;
    };

    const diffsMaxCount: number = ellipses.length;
    const foundDiffsCount: number = diffs.reduce((a, c) => a + (c ? 1 : 0), 0);

    return (
        <div className="App">
                <Container fluid>
                    <Row>
                        <Col lg={6} className="col-12">
                            <ClickPanel image={leftImage}
                                        ellipses={ellipses}
                                        diffs={diffs}
                                        setDiff={setDiff}
                            />
                        </Col>
                        <Col lg={6} className="col-12">
                            <ClickPanel image={rightImage}
                                        ellipses={ellipses}
                                        diffs={diffs}
                                        setDiff={setDiff}
                            />
                        </Col>
                    </Row>
                    <Row className="justify-content-center my-3">
                        <Col lg={3} className="col align-self-center">
                            <p className="text-center mb-0">Zeit</p>
                        </Col>
                        <Col lg={2} className="col align-self-center">
                            <p className="text-center mb-0 h4">
                                <Timer stopFlag={foundDiffsCount >= diffsMaxCount} stopCallback={stopCallback} />
                            </p>
                        </Col>
                        <Col lg={3} className="col align-self-center">
                            <p className="text-center mb-0">Minuten</p>
                        </Col>
                    </Row>
                </Container>
                <Container fluid className="bg-black py-2 position-relative overflow-hidden">
                    <Row className="justify-content-center my-3">
                        <Col lg={2} className="col align-self-center">
                            <p className="text-center mb-0">Gefunden</p>
                        </Col>
                        <Col lg={3} className="col col-auto align-self-center">
                            <p className="text-center mb-0 h4">{Array.from(Array(diffsMaxCount)).map((item, index) => (
                                <span key={index} className={index < foundDiffsCount ? "sp-flamme done" : "sp-flamme"} />
                            ))}</p>
                        </Col>
                        <Col lg={2} className="col align-self-center">
                            <p className="text-center mb-0">
                                <span className="sp-zahl">{foundDiffsCount}</span> von {diffsMaxCount}
                            </p>
                        </Col>
                    </Row>
                </Container>
        </div>
    );
}

export default App;
